import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import AppleState from '../../types/AppleState'

export const apple: Module<AppleState, RootState> = {
  namespaced: true,
  state: {},
  getters,
  actions,
  mutations
}
